/**
 * Preview-session flag.
 *
 * Researchers/orgadmins/superadmins can switch into the participant view to
 * see a study the way a participant meets it. That preview must never write:
 * a submission made from preview is real production data attributed to a
 * participant record that does not exist, so it pollutes exports, reports and
 * AI analysis while being invisible in every participant-organised view.
 *
 * The invariant this encodes: **an admin-tier user never writes participant
 * data.** It is deliberately not tied to which view is on screen — the
 * participant write paths are only reachable from the participant UI anyway,
 * and role is safer to key on than transient view state.
 *
 * Set once from useAuth when claims resolve; read synchronously by the
 * submission service, which is not a React component.
 */
let previewSession = false;

export const setPreviewSession = (value: boolean): void => {
  previewSession = value;
};

export const isPreviewSession = (): boolean => previewSession;
